;(() => {
  const mobileMenuToggle = document.querySelector('button#mobile-menu-toggle')
  mobileMenuToggle.addEventListener('click', function () {
    document.querySelector('#mobile-menu').classList.toggle('open')
    document.getElementsByTagName('HTML')[0].classList.add('overflow-hidden')
  })

  document
    .querySelectorAll('#close-mobile-menu, #mobile-menu-background')
    .forEach((element) => {
      element.addEventListener('click', () => {
        mobileMenuToggle.click()
        document
          .getElementsByTagName('HTML')[0]
          .classList.remove('overflow-hidden')
      })
    })

  document
    .querySelectorAll('#mobile-menu button.dropdown-toggle')
    .forEach((dropdown) => {
      dropdown.addEventListener('click', () => {
        dropdown.classList.toggle('active')
        const panel = dropdown.nextElementSibling
        panel.style.maxHeight = panel.style.maxHeight
          ? null
          : `${panel.scrollHeight}px`
      })
    })

  const level1List = document.querySelector('ul.level-1-list')

  document.querySelectorAll('button.level-1-more').forEach((button) => {
    button.addEventListener('click', function () {
      button.closest('.level-1-container').classList.add('active')
      level1List.classList.add('level-2-active')
    })
  })

  document
    .querySelectorAll('header.level-2-header button.back')
    .forEach((button) => {
      button.addEventListener('click', function () {
        button.closest('.level-1-container').classList.remove('active')
        level1List.classList.remove('level-2-active')
      })
    })

  //open the lighting by type menu by default
  document
    .querySelector(
      '#mobile-menu button.dropdown-toggle[data-name="lighting-by-type"]'
    )
    .click()
})()
